var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeReduceMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5859375,2c-0.644043,0-1.25,0.2509766-1.7070312,0.7070312L12.5859375,14H3c-1.6542969,0-3,1.3457031-3,3v14 c0,1.6542969,1.3457031,3,3,3h9.5859375l11.293457,11.2939453C24.3359375,45.7490234,24.9418945,46,25.5859375,46 C26.9169922,46,28,44.9169922,28,43.5859375V4.4140625C28,3.0830078,26.9169922,2,25.5859375,2z M26,43.5859375 c0,0.3388672-0.4682617,0.5302734-0.7070312,0.2929688L13.7070312,32.2929688C13.5195312,32.1054688,13.2651367,32,13,32H3 c-0.5512695,0-1-0.4482422-1-1V17c0-0.5517578,0.4487305-1,1-1h10c0.2651367,0,0.5195312-0.1054688,0.7070312-0.2929688 L25.2924805,4.1220703C25.534668,3.8808594,26.0004883,4.0742188,26,4.4140625V43.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4853516,15.5146484l-1.4140625,1.4140625c0.251709,0.251709,0.4857788,0.5160522,0.7069092,0.7888184 C36.2161255,19.491333,37,21.6850586,37,24s-0.7838745,4.508667-2.2218018,6.2824707 c-0.2211304,0.2727661-0.4552002,0.5371094-0.7069092,0.7888184l1.4140625,1.4140625C37.7519531,30.21875,39,27.2050781,39,24 S37.7519531,17.78125,35.4853516,15.5146484z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeReduceMedium);
export default __webpack_public_path__ + "static/media/volume-reduce--medium.b0735e193ec21cc880c26298ccc80274.svg";
export { ForwardRef as ReactComponent };